import React from "react";
import { useLocation } from "react-router-dom";

import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { Nav } from "@/typings";

interface DrawerNavBtnProps {
  data: Nav;
  onClick: (path: string) => void;
}

const DrawerNavBtn = ({ data, onClick }: DrawerNavBtnProps) => {
  const location = useLocation();
  const isActive = (data.matches || []).includes(location.pathname);

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={() => onClick(data.path)}
        selected={isActive}
        sx={{
          marginRight: "12px",
          paddingLeft: "0px",
          borderRadius: "0 50px 50px 0",
        }}
      >
        <ListItemIcon
          sx={{
            padding: "0 24px",
            minWidth: 0,
            color: ({ palette }) => (isActive ? palette.primary.main : palette.text.secondary),
          }}
        >
          {data.icon}
        </ListItemIcon>
        <ListItemText
          primary={data.name}
          sx={{
            "& .MuiTypography-root": {
              fontWeight: "bold",
              fontSize: "15px",
              color: ({ palette }) => (isActive ? palette.primary.main : palette.text.secondary),
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default React.memo(DrawerNavBtn);
